enum Application {
    Default = 'default',
    MiniApp = 'miniapp',
}

export default Application;